import { calculateHaversineDistance } from 'utils/shared/geo/calculateHaversineDistance';

interface Position {
  latitude: number;
  longitude: number;
}

interface VenueLike {
  latitude?: number | null;
  longitude?: number | null;
}

/** Miles from the viewer to a venue; null when either side has no coordinates. */
export const venueDistanceMiles = (
  position: Position | null | undefined,
  venue: VenueLike,
): number | null =>
  position && venue.latitude != null && venue.longitude != null
    ? calculateHaversineDistance({
        coord1: { latitude: position.latitude, longitude: position.longitude },
        coord2: { latitude: venue.latitude, longitude: venue.longitude },
        unit: 'miles',
      })
    : null;
